module.exports = __webpack_public_path__ + "static/img/logo.49f5f726.svg";